module.exports = __webpack_public_path__ + "img/pistol.eeebc1d8.webp";